import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import LogotypeBand from "./LogotypeBand.vue";

export default Node.create({
  name: "logotypeband",

  content: "logotype*",

  atom: true,

  parseHTML() {
    return [
      {
        tag: "logotype-band"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["logotype-band", HTMLAttributes, 0];
  },

  addNodeView() {
    return VueNodeViewRenderer(LogotypeBand);
  }
});
